import { useStore, useStoreUI } from '@assets/model/Store';
import { animated, useSpring } from '@react-spring/web';
import { observer } from 'mobx-react';
import { useState } from 'react';
import Lottie from 'react-lottie';
import { Logo } from '../Header/Logo';
import { Flex } from '../UI/Flex/Flex';
import animData from './loading.json';
export const LoadingAnim = observer(() => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        play: true,
        animationData: animData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <div className="fade-in" style={{ animationDelay: '0.45s' }}>
            <Lottie options={defaultOptions} height={400} width={400} />
        </div>
    );
});
